import { useState, useEffect, useRef } from 'react';

const FAQContact = () => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log({ nome, email, mensagem });
  };

  return (
    <section ref={sectionRef} className="py-20 bg-luxury-black relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle at 2px 2px, rgba(212, 175, 55, 0.3) 1px, transparent 0)',
            backgroundSize: '48px 48px',
          }}
        ></div>
      </div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div 
              className={`inline-flex items-center gap-2 px-5 py-2 bg-gold-400/10 border border-gold-400/30 rounded-full mb-6 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <i className="ri-customer-service-2-line text-gold-400"></i>
              <span className="text-gold-400 font-medium text-sm tracking-wide">Ainda tem dúvidas?</span>
            </div>

            <h2 
              className={`font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-white mb-4 transition-all duration-700 delay-100 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              Entre em <span className="text-gold-400">Contato</span>
            </h2>

            <p 
              className={`font-['Montserrat'] text-lg text-white/70 transition-all duration-700 delay-200 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              Nossa equipe está pronta para ajudar você
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div 
              className={`transition-all duration-700 delay-300 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <label
                htmlFor="nome"
                className="block font-['Montserrat'] text-sm font-medium text-white/90 mb-2"
              >
                Nome Completo
              </label>
              <input
                type="text"
                id="nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                className="w-full px-6 py-4 bg-white/5 border border-gold-400/20 rounded-xl text-white placeholder-white/40 focus:border-gold-400/50 focus:outline-none focus:ring-2 focus:ring-gold-400/20 transition-all font-['Montserrat'] text-sm"
                placeholder="Seu nome"
                required
              />
            </div>

            <div 
              className={`transition-all duration-700 delay-400 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <label
                htmlFor="email"
                className="block font-['Montserrat'] text-sm font-medium text-white/90 mb-2"
              >
                E-mail
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-6 py-4 bg-white/5 border border-gold-400/20 rounded-xl text-white placeholder-white/40 focus:border-gold-400/50 focus:outline-none focus:ring-2 focus:ring-gold-400/20 transition-all font-['Montserrat'] text-sm"
                placeholder="seu@email.com"
                required
              />
            </div>

            <div 
              className={`transition-all duration-700 delay-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <label
                htmlFor="mensagem"
                className="block font-['Montserrat'] text-sm font-medium text-white/90 mb-2"
              >
                Mensagem
              </label>
              <textarea
                id="mensagem"
                value={mensagem}
                onChange={(e) => setMensagem(e.target.value)}
                rows={6}
                className="w-full px-6 py-4 bg-white/5 border border-gold-400/20 rounded-xl text-white placeholder-white/40 focus:border-gold-400/50 focus:outline-none focus:ring-2 focus:ring-gold-400/20 transition-all resize-none font-['Montserrat'] text-sm"
                placeholder="Como podemos ajudar você?"
                required
              />
            </div>

            <button
              type="submit"
              className={`w-full px-8 py-4 bg-gradient-to-r from-gold-400 to-gold-500 text-luxury-black font-bold rounded-xl hover:shadow-2xl hover:shadow-gold-400/30 transition-all duration-700 delay-600 font-['Montserrat'] text-sm tracking-wide uppercase whitespace-nowrap ${
                isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
              } hover:scale-105`}
            >
              Enviar Mensagem
            </button>
          </form>

          {/* Contact Info */}
          <div 
            className={`mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-700 delay-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <div className="text-center">
              <div className="w-12 h-12 bg-gold-400/10 border border-gold-400/30 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-gold-400 text-xl"></i>
              </div>
              <p className="font-['Montserrat'] text-white/70 text-sm">contato@cartafuturo.org</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 bg-gold-400/10 border border-gold-400/30 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-time-line text-gold-400 text-xl"></i>
              </div>
              <p className="font-['Montserrat'] text-white/70 text-sm">Seg - Sex: 9h às 18h</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 bg-gold-400/10 border border-gold-400/30 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-customer-service-line text-gold-400 text-xl"></i>
              </div>
              <p className="font-['Montserrat'] text-white/70 text-sm">Resposta em até 24h</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQContact;
